import { render, staticRenderFns } from "./MultiPopupMenu.vue?vue&type=template&id=fb845ebc&scoped=true&"
import script from "./MultiPopupMenu.vue?vue&type=script&lang=js&"
export * from "./MultiPopupMenu.vue?vue&type=script&lang=js&"
import style0 from "./MultiPopupMenu.vue?vue&type=style&index=0&id=fb845ebc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb845ebc",
  null
  
)

export default component.exports